import { z } from 'zod';

export const schemaConsorsIdentificationNumber = z
    .string()
    .min(2)
    .max(12)
    .regex(/^[0-9a-zA-Z -]+$/, 'Invalid characters');
